import { TextCell, useDataTableUsingState } from '@juvare/common-data-table-ui/DataTable';
import React from 'react';
import { useDocumentLibraryTranslations } from './useDocumentLibraryTranslations';
import { useSystemRoleList } from './useSystemRoleList';
export function useSystemRoleTable() {
    const { t } = useDocumentLibraryTranslations();
    const { dataTableProps } = useDataTableUsingState({
        useDataProvider: useSystemRoleList,
        rowSelectionEnabled: true,
        defaultSortColumnKey: 'label',
    });
    const columns = React.useMemo(() => [
        {
            headerLabel: t('common.name'),
            sortKey: 'label',
            cellFunction: (row) => React.createElement(TextCell, null, row.label),
        },
    ], [t]);
    const defaultDataTableProps = Object.assign(Object.assign({}, dataTableProps), { columns, title: t('documents.systemRole') });
    return { dataTableProps: defaultDataTableProps };
}
